// CUECs section — cuec + cuec-mapping endpoints.
// listRcmControls now lives in core/api/rcm.ts (cross-section).
import { api } from "@/core/api/client";
import type { Cuec, UpdateCuecRequest, UpdateMappingsRequest } from "@/core/api/types";

export { listRcmControls } from "@/core/api/rcm";

export async function listCuecs(reportId: string): Promise<Cuec[]> {
  const data = await api.get<{ cuecs: Cuec[] }>(`/reports/${reportId}/cuecs`);
  return data.cuecs;
}

export async function updateCuec(cuecId: string, req: UpdateCuecRequest): Promise<Cuec> {
  const data = await api.patch<{ cuec: Cuec }>(`/cuecs/${cuecId}`, req);
  return data.cuec;
}

export async function updateCuecMappings(cuecId: string, req: UpdateMappingsRequest): Promise<void> {
  await api.patch<{ mappings: unknown }>(`/cuecs/${cuecId}/mappings`, req);
}

export async function createCuec(
  reportId: string,
  req: { text: string; short_title?: string; applicable?: boolean; coverage?: string }
): Promise<Cuec> {
  const data = await api.post<{ cuec: Cuec }>(`/reports/${reportId}/cuecs`, req);
  return data.cuec;
}

export async function deleteCuec(cuecId: string): Promise<void> {
  await api.delete<{ deleted: boolean }>(`/cuecs/${cuecId}`);
}
